export class Generator {
  id: number = 0

  constructor (value: number) {
    this.id = value
  }

  next (): number {
    this.id += 1
    return this.id
  }
}
